import axios from 'axios';

const version = '/api/v1';

export default {
  getIssues({ projectId, recordingId }) {
    let params = '';
    if (recordingId) params += `recordingId=${recordingId}`;
    else params = `projectId=${projectId}`;
    return axios({
      method: 'get',
      url: `${version}/issue?${params}`,
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/issues/api.js